import { render, staticRenderFns } from "./saleOffersAnnouncements-table.vue?vue&type=template&id=4fc5ab0e&"
import script from "./saleOffersAnnouncements-table.vue?vue&type=script&lang=js&"
export * from "./saleOffersAnnouncements-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports